<div class="container-fluid">
  <div class="row text-start mt-3">
    <span *ngIf="(isAuthenticated$ | async) === false" class="col-6 col-sm-3 img-container">
      <img class="img-size" src="assets/esano-images/eSano_eCoach_badge_edited.png" />
    </span>
    <h1 class="col-12 col-sm-6">
      Allgemeine Geschäftsbedingungen für die Nutzung der {{ platformName }}
    </h1>
    <a
      *ngIf="(isAuthenticated$ | async) === false"
      mat-button
      class="col-6 col-sm-3 mb-2"
      color="primary"
      (click)="redirectToLogin()"
    >
      <fa-icon [icon]="faArrowLeft"></fa-icon> {{ 'privacy.back_to_login' | translate }}
    </a>
    <hr />
  </div>

  <h3>I. Allgemeines / Gegenstand der AGB</h3>
  <ul>
    <li>
      Die folgenden Allgemeinen Geschäftsbedingungen (nachfolgend auch
      „AGB“) der Universität Ulm, Helmholtzstraße 16, 89081 Ulm (nachfolgend
      auch „UUlm“ oder „wir“ oder „Provider“) regeln die Benutzung der {{ platformName }}
      (nachfolgend auch „Software“), sowie ergänzend der Inhalte der UUlm („Inhalte“ oder „IMIs“)
      und das Vertragsverhältnis zwischen UUlm einerseits und Ihnen (nachfolgend auch „Nutzer:in“ oder „Sie“)
      andererseits. Bitte lesen Sie sich diese AGB vor der Nutzung der Software sorgfältig durch.
      Wenn Sie unseren AGB nicht zustimmen, dürfen Sie die Software nicht nutzen.
    </li>
    <li>
      Die Anwendung von allgemeinen Geschäftsbedingungen der Nutzer:in ist
      ausgeschlossen. Abweichende, entgegenstehende oder ergänzende
      Geschäftsbedingungen der Nutzer:in werden nur dann und insoweit
      Vertragsbestandteil, wenn wir ihrer Geltung ausdrücklich zugestimmt haben.
    </li>
    <li>
      Bitte beachten Sie, dass die Software von der UUlm im Rahmen von
      Forschungs- und Entwicklungsprojekten, und nicht kommerziell betrieben
      wird, und daher Ihre Ansprüche auf Verfügbarkeit und
      Störungsbehebungen in Bezug auf die Software im Vergleich zu
      kommerziellen Anbietern nach Maßgabe dieser AGB deutlich
      eingeschränkt sein können. Die Nutzung der Software durch Sie erfolgt
      freiwillig und ohne Rechtsanspruch hierauf gegen uns.
    </li>
  </ul>

  <h3>II. Vertragsgegenstand und Leistungsumfang</h3>
  <ul>
    <li>
      Gegenstand des Vertrags ist die zeitlich auf die Dauer des Vertrags
      begrenzte Gewährung der Nutzung der Software im Unternehmen der Nutzer:in
      über das Internet sowie die Bereitstellung von Speicherplatz auf den Servern des Providers.
    </li>
    <li>
      Die Software ermöglicht es Ihnen, eingebunden in konkrete Forschungsprojekte
      im Bereich der Versorgungsforschung, die Plattform im Rahmen der psychotherapeutischen
      oder ärztlichen Behandlung (auch „Behandlung“) Ihrer Patient:innen zu nutzen.
      Hierzu stehen Ihnen unterschiedliche Internet- und Mobile-basierten Interventionen (IMIs) bereit.
      Regelungen zur Nutzung der IMIs finden Sie unter Ziffer XII. bzw. jeweils auf
      der Plattform beim Zugang zu den jeweiligen IMIs.
    </li>
    <li>
      Bitte beachten Sie, dass Sie als Psychotherapeut:in oder Ärzt:in (auch
      „Behandler“) selber freiwillig entscheiden, ob überhaupt, und im Rahmen
      welcher konkreten Behandlungen Sie die Software verwenden möchten, und
      welche IMIs Sie, vorbehaltlich der Einräumung von Nutzungsrechten durch
      uns bzw. durch den Rechteinhaber (XII.), einsetzen möchten. Die Vergütung
      der Behandlungen erfolgt in der Regel über die Krankenkassen; die UUlm
      macht jedoch ausdrücklich keine Zusage zur Vergütungsfähigkeit des
      Einsatzes der Software im Rahmen von Behandlungsverträgen. Die UUlm
      macht weder eine Zusage über, noch übernimmt sie die Haftung für die
      Eignung des Einsatzes der Software für einen bestimmten Therapieerfolg,
      noch für die Erzielung bestimmter Behandlungsergebnisse. Das Verhältnis
      zwischen Ihnen und Ihren Patient:innen richtet sich ausschließlich nach dem
      zwischen Ihnen und Ihrer Patient:in abgeschlossenen Behandlungsvertrag.
      Aspekte der Aufklärung, Indikationsstellung und Sorgfaltspflicht gegenüber
      Patient:innen obliegen alleine Ihnen.
    </li>
    <li>
      Über die Nutzung der Software stellen wir den Patient:innen bei ihrer ersten Anmeldung gesonderte
      Nutzungs-AGB auf der {{ patientName }} zur Verfügung.
    </li>
  </ul>

  <h3>III. Leistungen des Providers; Software und Speicherplatz</h3>
  <ul>
    <li>
      Der Provider gewährt der Nutzer:in die Nutzung der jeweils aktuellsten
      Version der Software über das Internet mittels Zugriffes durch einen Browser.
    </li>
    <li>
      Die Software wird von der UUlm im Rahmen von Forschungs- und
      Entwicklungsprojekten betrieben und kostenfrei bereitgestellt. UUlm
      übernimmt vor diesem Hintergrund keine Gewährleistung für die
      Funktionsdauer oder -fähigkeit oder eine bestimmte Funktionalität. Der
      Provider kann, ohne hierzu verpflichtet zu sein, die Software jederzeit
      aktualisieren oder weiterentwickeln und insbesondere aufgrund
      geänderter Rechtslage, technischer Entwicklungen oder zur
      Verbesserung der IT-Sicherheit anpassen.
    </li>
    <li>
      Eine Anpassung auf die individuellen Bedürfnisse oder die IT-Umgebung
      der Nutzer:in schuldet der Provider nicht.
    </li>
    <li>
      Die Durchführung von Wartungsarbeiten steht im eigenen Ermessen des
      Providers. Eine Information an die Nutzer:in über etwaige hiermit
      verbundene Einschränkungen, erfolgt im eigenen Ermessen des Providers,
      in der Regel jedoch mindestens 24 Stunden im Voraus. Ein Anspruch der Nutzer:in
      auf Durchführung bestimmter Wartungsarbeiten am System besteht nicht.
    </li>
    <li>
      Der Provider stellt der Nutzer:in, soweit im Einzelfall für die Nutzer:in nach
      Ermessen des Providers freigeschaltet, zum Zwecke der Nutzung
      bestimmter Funktionen, wie zum Beispiel der Tagebuch-Funktion und der
      Gesprächs-Funktion, nach eigenem Ermessen Speicherplatz auf seinen
      Servern zur Verfügung. Die Funktionen ermöglichen das Abfassen und
      Speichern von Textdateien und das Senden und Empfangen von
      Textnachrichten (zusammen „Daten“) an und von Ihren Patient:innen. Der
      Provider gewährleistet weder einen Anspruch auf eine bestimmte Größe
      an Speicherplatz, noch die Abrufbarkeit der von der Nutzer:in auf der
      Plattform gespeicherten Daten.
    </li>
    <li>
      Der Provider wird die Daten mit angemessener Sorgfalt schützen.
      Den Provider treffen jedoch keine Verwahrungs- oder Obhutspflichten hinsichtlich der Daten.
      Für eine ausreichende Sicherung der Daten ist die Nutzer:in verantwortlich.
    </li>
    <li>
      Die Nutzer:in bleibt Inhaber der auf den Servern des Providers abgelegten Daten.
      Die nach Maßgabe von Abschnitt XII. (2) dieser AGB der UUlm eingeräumten Rechte bleiben hiervon unberührt.
    </li>
  </ul>

  <h3>IV. Nutzungsumfang und -rechte</h3>
  <ul>
    <li>
      Eine physische Überlassung der Software an die Nutzer:in erfolgt nicht.
    </li>
    <li>
      Die Software und alle damit zusammenhängenden Datenbanken,
      Grafiken, Benutzeroberflächen, Designs, Bezeichnungen, Namen und
      Marken sind durch das Urheberrecht, das Markenrecht und ggf. andere
      Schutzrechte geschützt. Im Verhältnis zu Ihnen gilt grundsätzlich allein
      die UUlm als Inhaberin und Berechtigte aller Rechte geistigen Eigentums;
      für die Nutzung der IMIs gelten jedoch abweichend hiervon die NutzungsAGB der jeweiligen Rechteinhaber der IMIs,
      welche Sie auf der Plattform finden, sowie Abschnitt XII. dieser AGB.
    </li>
    <li>
      Unter der Bedingung der Einhaltung dieser AGB und der sonstigen
      anwendbaren Bestimmungen, gewährt Ihnen die UUlm das nicht-ausschließliche,
      nicht-unterlizenzierbare und nicht übertragbare, zeitlich
      auf die Dauer des Vertrags beschränkte Recht, die Software mittels
      Zugriffes über einen Browser nach Maßgabe dieser AGB zu nutzen.
      Gestattet ist der Nutzer:in jedoch das Anlegen von einer unbeschränkten
      Anzahl an Patient:innenaccounts über die dafür vorgesehene Funktion
      der Software. Vor der Freigabe eines Patient:innenaccounts müssen Sie
      sicherstellen, dass die Patient:in Sie von der Einhaltung der ärztlichen
      bzw. psychotherapeutischen Schweigepflicht gegenüber der UUlm
      wirksam befreit hat, und Ihnen gegenüber in die Weitergabe seiner
      personenbezogenen Daten, insbesondere seiner E-Mail-Adresse an die
      UUlm eingewilligt hat. Die rechtliche Verantwortung hierfür obliegt alleine Ihnen.
    </li>
    <li>
      Das Nutzungsrecht erlischt mit Ablauf der Vertragslaufzeit und kann von
      der UUlm darüber hinaus jederzeit beschränkt oder widerrufen werden.
    </li>
    <li>
      Die Nutzer:in darf die Software nur im Rahmen ihrer eigenen
      psychotherapeutischen, ärztlichen oder wissenschaftlichen Tätigkeit nutzen.
      Eine weitergehende Nutzung der Software durch die Nutzer:in ist nicht gestattet.
    </li>
  </ul>

  <h3>V. Pflichten der Nutzer:in</h3>
  <ul>
    <li>
      Der Vertrag kommt durch elektronische Zustimmung zu unseren AGB zustande.
      Wenn Sie den AGB nicht zustimmen, dürfen Sie die Software nicht nutzen.
    </li>
    <li>
      Die Nutzer:in hat die ihr übermittelten Zugangsdaten dem Stand der
      Technik entsprechend vor Zugriffen Dritter zu schützen und zu
      verwahren. Die Nutzer:in wird dafür sorgen, dass eine Nutzung nur im
      vertraglich vereinbarten Umfang geschieht. Ein unberechtigter Zugriff ist
      dem Provider unverzüglich mitzuteilen.
    </li>
    <li>
      Die Nutzer:in darf im Rahmen der Nutzung der Software keine
      rechtswidrigen Handlungen vornehmen und/oder gegen anwendbare
      Gesetze verstoßen, insbesondere nicht:
      <ul id="innerList" class="topGap">
        <li>
          Inhalte speichern und/oder übermitteln, die:
          <ul class="topGap">
            <li>
              belästigend, beleidigend, jugendgefährdend oder in sonstiger
              Weise rechtswidrig sind;
            </li>
            <li>
              die Rechte Dritter, insbesondere Urheberrechte, Persönlichkeitsrechte
              oder sonstige Eigentumsrechte verletzen;
            </li>
            <li>
              manipulierte Inhalte darstellen;
            </li>
            <li>
              Scraping- oder ähnlichen Techniken einsetzen, um Inhalte
              zusammenzustellen, zu einem anderen Zweck zu nutzen,
              erneut zu veröffentlichen oder auf andere Weise zu nutzen.
            </li>
          </ul>
        </li>
        <li>
          Techniken einsetzen oder automatisierte oder anderweitige Dienste
          nutzen, die darauf angelegt sind, Nutzer:innenaktivitäten falsch
          darzustellen, wie etwa durch die Nutzung von Bots, Botnetzen,
          Scripten, Apps, Plugins, Erweiterungen oder sonstigen
          automatisierten Mitteln zur Registrierung von Konten, zum Abspielen
          von Inhalt, zum Versand von Nachrichten, zum Posten von
          Kommentaren oder zur anderweitigen Handlungen;
        </li>
        <li>
          persönliche Daten über andere Nutzer:in sammeln, speichern oder
          übermitteln. Das gilt nicht, soweit die Betroffenen hiermit
          einverstanden sind, insbesondere soweit der Einsatz der Software
          im Rahmen einer Behandlung das Sammeln, Speichern und
          Übermitteln entsprechender Daten der Patient:innen gebietet und
          der Behandlungsvertrag dies erlaubt.
        </li>
      </ul>
    </li>
    <li>
      Die Nutzer:in hat in eigener Verantwortung regelmäßig angemessene Datensicherungen vorzunehmen.
    </li>
  </ul>

  <h3>VI. Support</h3>
  <ul>
    <li>
      Der Provider richtet für technische Anfragen der Nutzer:in zu Funktionen
      der Software einen Support-Service unter
      <a href="mailto:support@esano-trainings.de">support&#64;esano-trainings.de</a>
      ein. Die Anfragen werden grundsätzlich in zeitlicher Reihenfolge ihres Eingangs bearbeitet.
    </li>
    <li>
      Da die Software von der UUlm im Rahmen von Forschungs- und
      Entwicklungsprojekten entwickelt wurde und genutzt wird, gewährt die
      UUlm keine bestimmte Gesamtverfügbarkeit des Systems. Im Falle
      technischer Störungen besteht kein Anspruch der Nutzer:in auf
      Störungsbehebung; der Provider wird sich jedoch bemühen, ihm
      gemeldete Störungen in einem angemessenen Zeitraum zu beheben.
    </li>
  </ul>

  <h3>VII. Gewährleistung / Haftung</h3>
  <ul>
    <li>
      Die Haftung der UUlm für Schadens-, Freistellungs- und Aufwendungsersatzansprüche der Nutzer:in
      bei Pflichtverletzungen wird ausgeschlossen. Dieser Ausschluss gilt ausdrücklich auch für die Haftung
      für Schäden, die der Nutzer:in im Rahmen von Deaktivierungen der Plattform durch die UUlm entstehen,
      insbesondere im Fall von Datenverlusten. Ausgeschlossen sind insbesondere auch Ansprüche aus
      entgangenem Gewinn oder Ansprüche aus Regresshaftung für Ansprüche auf Schadenersatz von Dritten gegen
      die Nutzer:in aufgrund von Schäden, die diesen im Rahmen der Nutzung der Plattform durch die UUlm entstehen.
    </li>
    <li>
      Die Haftungsbeschränkungen gelten nicht für Ansprüche wegen
      Vorsatzes und grober Fahrlässigkeit, bei der Verletzung des Lebens, des
      Körpers oder der Gesundheit, bei Arglist, soweit das
      Produkthaftungsgesetz zur Anwendung kommt sowie bei Garantieversprechen.
    </li>
    <li>
      Der Provider gewährleistet nicht, dass durch die Nutzung der Software
      keine Rechte Dritter verletzt werden.
    </li>
  </ul>

  <h3>VIII. Keine Vergütungspflicht</h3>
  <div class="leftPadding">
    Die Software wird der Nutzer:in von der UUlm unentgeltlich zur Verfügung
    gestellt. Sämtliche Vergütungs-/ Förderungs- oder sonstige Zahlungsansprüche
    im Hinblick auf die Vergütung von Behandlungen, im Rahmen derer die Software
    eingesetzt wird, zwischen dem Nutzer:in und den gesetzlichen Krankenkassen
    oder dem Patienten, sowie zwischen der UUlm und den gesetzlichen
    Krankenkassen bleiben hiervon unberührt. Diese berühren ausdrücklich nicht die
    Unentgeltlichkeit der Leistungserbringung der UUlm gegenüber der Nutzer:in.
  </div>

  <h3>IX. Vertraulichkeit; Datenschutz</h3>
  <ul>
    <li>
      Die Informationen über die Verarbeitung der personenbezogenen Daten
      im Rahmen der Nutzung der Software finden Sie hier.
    </li>
    <li>
      UUlm und die Nutzer:in werden die für sie jeweils geltenden anwendbaren
      datenschutzrechtlichen Bestimmungen einhalten.
    </li>
    <li>
      UUlm und die Nutzer:in verpflichten sich, über alle vertraulichen
      Informationen (einschließlich Geschäftsgeheimnissen), die sie im
      Zusammenhang mit diesem Vertrag und dessen Durchführung erfahren,
      Stillschweigen zu bewahren und diese nicht gegenüber Dritten
      offenzulegen, weiterzugeben oder auf sonstige Art zu verwenden.
      Vertrauliche Informationen sind dabei solche, die als vertraulich
      gekennzeichnet sind oder deren Vertraulichkeit sich aus den Umständen
      ergibt, unabhängig davon, ob sie in schriftlicher, elektronischer,
      verkörperter oder mündlicher Form mitgeteilt worden sind. Die
      Geheimhaltungsverpflichtung gilt nicht, soweit der Provider gesetzlich
      oder aufgrund bestands- bzw. rechtskräftiger Behörden- oder
      Gerichtsentscheidung zur Offenlegung der vertraulichen Information verpflichtet ist.
    </li>
  </ul>

  <h3>X. Vertragslaufzeit und Beendigung</h3>
  <ul>
    <li>
      Der Vertrag tritt in Kraft, sobald Sie diese AGB elektronisch akzeptieren
      und wird für die Dauer der jeweiligen Studie bzw. des jeweiligen
      Forschungsprojekts abgeschlossen. Über die Dauer werden Sie gesondert informiert.
    </li>
    <li>
      Der Vertrag kann von beiden Parteien jederzeit ohne Einhaltung einer
      Kündigungsfrist gekündigt werden. Die Kündigung der Nutzer:in ist an
      <a href="mailto:support@esano-trainings.de">support&#64;esano-trainings.de</a>
      zu richten. Sie haben hierbei die Wahl, die Löschung Ihres Accounts
      (Löschungsanfrage) oder die Pseudonymisierung Ihrer Daten (Pseudonymisierungsanfrage)
      zu verlangen. Wir werden Ihren Account innerhalb eines angemessenen
      Zeitraums nach Ihrer Löschungsanfrage löschen bzw. nach Ihrer
      Pseudonymisierungsanfrage pseudonymisieren.
    </li>
    <li>
      Die von der Nutzer:in auf der Plattform gespeicherten Daten (siehe III. (5))
      werden unwiderruflich gelöscht, sobald wir Ihre Löschungsanfrage
      bearbeitet haben. Sie werden darauf hingewiesen, dass sie die von Ihnen
      gespeicherten Daten vor ihrer Löschung nach eigenem Ermessen, auf
      eigene Kosten und auf eigenes Risiko herunterladen und auf eigenen
      Datenträgern sichern können. Sie werden darauf hingewiesen, dass mit
      erfolgter Löschung keine Möglichkeit der vorgenannten Datensicherungen mehr besteht.
      Es besteht ausdrücklich kein Anspruch auf Datenwiederherstellung nach deren Löschung.
    </li>
  </ul>

  <h3>XI. Schlussbestimmungen</h3>
  <ul>
    <li>
      Soweit in diesen AGB keine ausdrücklichen Regelungen getroffen sind,
      gelten die Vorschriften des Leihvertragsrechts, §§ 598 ff. BGB.
    </li>
    <li>
      Sollten einzelne Regelungen dieses Vertrags unwirksam oder nicht
      durchführbar sein, bleibt die Wirksamkeit der übrigen Regelungen hiervon
      unberührt. UUlm und die Nutzer:in werden solche Regelungen durch
      wirksame und durchführbare Regelungen ersetzen, die dem Sinn und
      wirtschaftlichen Zweck sowie dem Willen von UUlm und der Nutzer:in bei
      Vertragsschluss möglichst gleichkommen. Entsprechendes gilt im Falle einer Vertragslücke.
    </li>
    <li>
      Mündliche Nebenabreden zu diesem Vertrag bestehen nicht.
      Soweit Sie im Einzelfall aufgrund Ihrer Teilnahme an einer Studie,
      in deren Rahmen Sie die Software nutzen, besonderen studienbezogenen Bedingungen
      schriftlich oder elektronisch zugestimmt haben,
      und/oder weitere schriftliche oder elektronische Vereinbarungen hierzu mit der UUlm
      getroffen haben (zusammen „studienbezogene Vereinbarungen“),
      so gehen im Fall von Widersprüchen zwischen diesen AGB und den besonderen studienbezogenen Vereinbarungen,
      die besonderen, studienbezogenen Vereinbarungen dieses AGB vor.
    </li>
    <li>
      Es gilt deutsches Recht unter Ausschluss der kollisionsrechtlichen
      Bestimmungen und des Übereinkommens der Vereinten Nationen über
      Verträge über den internationalen Warenverkauf vom 11.4.1980 (UN-Kaufrecht).
    </li>
    <li>
      Die UUlm behält sich das Recht vor, diese AGB jederzeit mit Wirkung für
      die Zukunft zu ändern oder zu erweitern, sofern dies erforderlich erscheint.
      Für neue Vertragsabschlüsse gelten dann jeweils die AGB in
      der jeweils zum Vertragsabschluss aktuellen Fassung.
    </li>
    <li>
      Im Rahmen von laufenden Dauerschuldverhältnissen werden AGB-Änderungen nur durchgeführt,
      sofern dies die Nutzer:in nicht wider Treu und Glauben benachteiligt.
      Eine Änderung kann insbesondere notwendig sein, um Anpassungen an eine Änderung der Rechtslage vorzunehmen.
      Auch neu ergangene Gerichtsentscheidungen gelten als Änderung der Rechtslage.
      Änderungen und Fortentwicklungen des Angebots können ebenso eine Änderung oder Ergänzung der AGB notwendig machen.
    </li>
  </ul>

  <h3>XII. Nutzung der Inhalte der e-Sano Plattform (IMIs) im Rahmen der Softwarenutzung / Abtretung von Studienergebnissen</h3>
  <ul>
    <li>
      Für die Nutzung der Internet- und Mobile-basierten Interventionen (IMIs) im
      Eigentum der UUlm, die der Nutzer:in nach eigenem Ermessen der UUlm freigeschaltet werden,
      erhält die Nutzer:in ein nicht-ausschließliches, nicht-unterlizenzierbares und nicht übertragbares,
      zeitlich auf die Dauer des Vertrags beschränktes Nutzungsrecht.
      Darüber hinaus gelten die vorstehenden AGB zur Nutzung der Software entsprechend.
    </li>
    <li>
      Soweit die Nutzer:in die Software und die IMIs im Rahmen einer Studie
      bzw. eines Forschungsprojekts nutzt, erklärt sie bereits jetzt die Abtretung
      aller Rechte an den während der Studie gewonnenen (übertragbaren)
      Studienergebnissen an die UUlm, welche die Abtretung annimmt.
      An urheberrechtlich geschützten Studienergebnissen räumt die Nutzer:in der
      UUlm ein exklusives, unbefristetes, übertragbares Nutzungsrecht für alle Nutzungsarten ein.
      Die Rechte der Nutzer:in an den in den Patientenakten enthaltenen Daten der Patient:innen bleiben davon unberührt.
      Studienergebnisse sind alle während der Laufzeit dieses Vertrages entstehenden Ergebnisse, Daten und Erkenntnisse,
      die bei der prüfplangemäßen Durchführung der Studie erreicht oder generiert werden, wobei hier auch Ergebnisse,
      Daten und Erkenntnisse eingeschlossen sind, die dem gewerblichen Rechtsschutz zugänglich sind.
    </li>
    <li>
      Für die Einräumung von Nutzungsrechten an IMIs im Eigentum anderer
      Einrichtungen, und für die Abtretung von Studienergebnissen im Rahmen
      der Nutzung der Software bei Studien, die nicht unter der Projektleitung
      der UUlm durchgeführt werden, gelten die Nutzungsbedingungen der
      rechteinhabenden bzw. projektleitenden Einrichtungen.
      Diese finden Sie in der Regel in der Plattform bei den jeweiligen Lektionen.
      Die UUlm übernimmt keinerlei Haftung für IMIs im Eigentum anderer Einrichtungen.
    </li>
    <li>
      Auf die Nutzung bestimmter IMIs besteht kein rechtlicher Anspruch.
    </li>
  </ul>

</div>
